import { createContext, useContext, useEffect, useState } from "react";
import Globals from "../services/Globals";
import { Nederlands, TStrings } from "../constants/languages/lang";
import { TReviews, TSize } from "../constants/types";

interface GlobalContextProps {
    DevEnabled : boolean;
    DebugEnabled: boolean;
    BitcoinEnabled: boolean;   
    ReviewID: string; 
    DLog: Function;
    ImagesUrlVersionAddition: string;

    GlobalInit: Function;
    
    CacheCollectedAt: Date;
    SITE_MESSAGE_START_DATE : Date;
    SITE_MESSAGE_END_DATE : Date;
    Refresh: Function;
    Strings: TStrings;
    SetStrings: Function;
    InitDone: boolean;
    SITE_MESSAGE: string;
    HIDDEN_SETS: string;
    selectedBaseSetKey: number;
    selectedSetKey: number;
    selectedSetName: string;
    SetselectedSetName: Function;
    CAROUSEL_PROMO_SET_ID: string;
    PROMO1_IMAGE_URL: string;
    PROMO2_IMAGE_URL: string;
    CONFIG_PROMO2_IMAGE_URL: string;

    Callbacks: Function[];

    MainCarouselSets : number[];
    SetMainCarouselSets: Function;

    PageWidth: number;
    SetPageWidth: Function;

    IsMobile: boolean;
    SetIsMobile: Function;

    ShowMessage: Function;
    SetShowMessage: Function;

    ToastMessage: string;
    SetToastMessage: Function;

    AddCallback : Function;
    ClearCallBack : Function;

    AnimationsEnabled: boolean;
    SetAnimationsEnabled: Function;
    ShowFooter: boolean;
    SetShowFooter: Function;
    Reviews: TReviews;
    showAvailableOnly: boolean;
    setshowAvailableOnly: Function;
    windowSize: TSize;
    SetwindowSize: Function;
    GlobalImagesVersion: string;
}

const GlobalContext = createContext<GlobalContextProps>({} as GlobalContextProps);

export const useGlobalContextContext = () => {
  const context = useContext(GlobalContext);
  if (context === undefined) {
    throw new Error("Custom context GlobalContext must be used within a CustomContextProvider");
  }
  return context;
};

export const GlobalContextProvider: React.FC = ({ children }) => {
    const StartImagesString = Date.now().toString();
    const [Callbacks,SetCallbacks] = useState<Function[]>([]);
    const [MainCarouselSets,SetMainCarouselSets] = useState<number[]>([]);
    const [PageWidth,SetPageWidth] = useState<number>(window.innerWidth - 25 > 1232 ? 1232 : window.innerWidth);
    const [IsMobile,SetIsMobile] = useState<boolean>(false);
    const [ShowMessage,SetShowMessage] = useState<Function>();
    const [ToastMessage, SetToastMessage] = useState<string>();
    const [AnimationsEnabled, SetAnimationsEnabled] = useState<boolean>(true);
    const [ShowFooter, SetShowFooter] = useState<boolean>(false);

    const [CacheCollectedAt, SetCacheCollectedAt] = useState<Date>();
    const [SITE_MESSAGE_START_DATE, SetSITE_MESSAGE_START_DATE] = useState<Date>();
    const [SITE_MESSAGE_END_DATE, SetSITE_MESSAGE_END_DATE] = useState<Date>();
    const [Refresh, SetRefresh] = useState<Function>();
    const [Strings, SetStrings] = useState<TStrings>(Nederlands);
    const [InitDone, SetInitDone] = useState<boolean>();
    const [SITE_MESSAGE, SetSITE_MESSAGE] = useState<string>();
    const [HIDDEN_SETS, SetHIDDEN_SETS] = useState<string>();
    const [selectedBaseSetKey, SetselectedBaseSetKey] = useState<number>();
    const [selectedSetKey, SetselectedSetKey] = useState<number>();
    const [selectedSetName, SetselectedSetName] = useState<string>();
    const [CAROUSEL_PROMO_SET_ID, SetCAROUSEL_PROMO_SET_ID] = useState<string>();
    const [PROMO1_IMAGE_URL, SetPROMO1_IMAGE_URL] = useState<string>();
    const [PROMO2_IMAGE_URL, SetPROMO2_IMAGE_URL] = useState<string>();
    const [CONFIG_PROMO2_IMAGE_URL, SetCONFIG_PROMO2_IMAGE_URL] = useState<string>();
    const [Reviews, SetReviews] = useState<TReviews>();
    const [GlobalImagesVersion, SetGlobalImagesVersion] = useState<string>("1");
    const [showAvailableOnly, setshowAvailableOnly] = useState<boolean>(true);
    const [windowSize,SetwindowSize] = useState<TSize>({ x: window.innerWidth > 1232 ? 1232 : window.innerWidth, y: window.innerHeight });

    let DevEnabled = Globals.GetParam('dev') ? true : false;
    let DebugEnabled = Globals.GetParam('debug') ? true : false;
    const BitcoinEnabled = Globals.GetParam('BTC') ? true : false;
    const ReviewID = Globals.GetParam('reviewid');
    const ImagesUrlVersionAddition = Date.now().toString();

    if (document.location.origin === "http://localhost:3000") {
      DevEnabled = true;
      DebugEnabled = true;
    }

    const AddCallback = (f: Function) => {
      let buff = Callbacks;
      buff.push(f);
      SetCallbacks(buff);
    }

    const ClearCallBack = () => {
      SetCallbacks([]);
    }

    const GlobalInit = (data, _tStrings: TStrings, _showMessage : Function, _IsMobile: boolean, _PageWidth: number, refresh:Function) => {
      SetStrings(_tStrings);
      SetShowMessage(_showMessage);
      SetIsMobile(_IsMobile);
      SetPageWidth(_PageWidth);
      SetReviews(data.reviews);

      SetRefresh(refresh);
      SetCacheCollectedAt(new Date(data.CollectedAt));
      data.config.forEach(d => {
          switch (d.name) {
              case "HIDDEN_SETS":
                  SetHIDDEN_SETS(d.value);
                  break;
              case "selectedBaseSetKey":
                  SetselectedBaseSetKey(Number(d.value));
                  break;
              case "selectedSetKey":
                  SetselectedSetKey(Number(d.value));
                  break;
              case "CAROUSEL_PROMO_SET_ID":
                  SetCAROUSEL_PROMO_SET_ID(d.value);
                  break;
              case "PROMO1_IMAGE_URL":
                  SetPROMO1_IMAGE_URL(d.value);
                  break;
              case "PROMO2_IMAGE_URL":
                  SetPROMO2_IMAGE_URL(d.value);
                  break;
              case "CONFIG_PROMO2_IMAGE_URL":
                  SetCONFIG_PROMO2_IMAGE_URL(d.value);
                  break;
              case "SITE_MESSAGE":
                  SetSITE_MESSAGE(d.value);
                  break;
              case "SITE_MESSAGE_START_DATE":
                  SetSITE_MESSAGE_START_DATE(new Date(d.value));
                  break;
              case "SITE_MESSAGE_END_DATE":
                  SetSITE_MESSAGE_END_DATE(new Date(d.value));
                  break;
              case "DefaultSoldOutEnabled":
                  if (d.value === "1") {
                    setshowAvailableOnly(false);
                  } else {
                    setshowAvailableOnly(true);
                  }
                  break;
              case "GlobalImagesVersion":
                  SetGlobalImagesVersion(d.value);
                  break;
              case "MainCarouselSets":
                  const parts = d.value.split(',');
                  let mcs: number[] = [];
                  parts.forEach(p => {
                      mcs.push(Number(p));
                  });
                  SetMainCarouselSets(mcs);
                  break;
              default:
                  break;
          }
      });
      SetInitDone(true);
      Callbacks.forEach(f => {
          f();
      });
    }

    const DLog = (message) => {
      if (DebugEnabled) {
        switch (typeof message) {
          case "string":
            console.log("DEBUG: " + message);
            break;
          default:
            console.log("[START DEBUG OBJ]");
            console.log(message);
            console.log("[END DEBUG OBJ]");
            break;
        }
      }
    }

    return (
        <GlobalContext.Provider value={{DevEnabled,
                                        DebugEnabled,
                                        BitcoinEnabled,
                                        ReviewID,
                                        DLog,
                                        ImagesUrlVersionAddition,
                                        GlobalInit,
                                        CacheCollectedAt,
                                        SITE_MESSAGE_START_DATE,
                                        SITE_MESSAGE_END_DATE,
                                        Refresh,
                                        Strings,
                                        SetStrings,
                                        InitDone,
                                        SITE_MESSAGE,
                                        HIDDEN_SETS,
                                        selectedBaseSetKey,
                                        selectedSetKey,
                                        selectedSetName,
                                        SetselectedSetName,
                                        CAROUSEL_PROMO_SET_ID,
                                        PROMO1_IMAGE_URL,
                                        PROMO2_IMAGE_URL,
                                        CONFIG_PROMO2_IMAGE_URL,
                                        Callbacks,
                                        MainCarouselSets,
                                        SetMainCarouselSets,
                                        PageWidth,
                                        SetPageWidth,
                                        IsMobile,
                                        SetIsMobile,
                                        ShowMessage,
                                        SetShowMessage,
                                        ToastMessage,
                                        SetToastMessage,
                                        AddCallback,
                                        ClearCallBack,
                                        AnimationsEnabled,
                                        SetAnimationsEnabled,
                                        ShowFooter,
                                        SetShowFooter,
                                        Reviews,
                                        showAvailableOnly,
                                        setshowAvailableOnly,
                                        windowSize,
                                        SetwindowSize,
                                        GlobalImagesVersion}}>
            {children}
        </GlobalContext.Provider>
    );
};

export default GlobalContext;